import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../contexts/AppContext';
import ThemeContext from '../contexts/ThemeContext'; 
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';


const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { dispatch } = useContext(AppContext);
  const { isDark } = useContext(ThemeContext); 
  const navigate = useNavigate();

  const handleLogin = async e => {
    e.preventDefault();
    try {
      const response = await axios.post('https://ak-carckers-backend-api.onrender.com/api/auth/login', { email, password });

      localStorage.setItem("token", response.data.token); 
      dispatch({ type: 'SET_TOKEN', payload: response.data.token });
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <div className={`page-shell min-vh-100 ${isDark ? 'bg-dark text-light' : 'bg-light text-dark'}`}>
      <div className="text-center pt-5">
        <h3 className="fw-bold text-danger">
          Welcome to AK Crackers Dashboard
        </h3>
        <p className={`mt-2 ${isDark ? 'text-light opacity-75' : 'text-muted'}`}>
          Please login to access your dashboard
        </p>
      </div>
      <main className="container py-4">
        <div 
          className={`card shadow-sm p-4 mx-auto border-0 ${isDark ? 'bg-secondary bg-opacity-25 text-white' : 'bg-white text-dark'}`} 
          style={{ maxWidth: 420, backgroundColor: isDark ? '#1e1e1e' : '#ffffff' }}
        >
          <h1 className="h4 mb-3 fw-bold">Admin Login</h1>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label className={`form-label ${isDark ? 'text-light' : 'text-dark'}`}>Email</label>
              <input 
                type="email" 
                className={`form-control ${isDark ? 'bg-dark text-white border-secondary' : 'bg-white text-dark'}`} 
                value={email} 
                onChange={e => setEmail(e.target.value)} 
                required 
              />
            </div>
            <div className="mb-3">
              <label className={`form-label ${isDark ? 'text-light' : 'text-dark'}`}>Password</label>
              <input 
                type="password" 
                className={`form-control ${isDark ? 'bg-dark text-white border-secondary' : 'bg-white text-dark'}`} 
                value={password} 
                onChange={e => setPassword(e.target.value)} 
                required 
              />
            </div>
            <button className="btn btn-danger w-100 fw-bold py-2 mt-2" type="submit">Login</button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AdminLoginPage;